<template>
  <div class="detailed_list">
    <Carousel :bannerImg="bannerImg" :bannerInfo="bannerInfo" />


    <div class="w detals_box flex">
      <!-- 侧边栏 -->
      <div class="tabs">
        <ul>
          <li
            :class="['li_yuan', index == tabsIdx ? 'tabs_li_bg' : '']"
            v-for="(item, index) in tabsList"
            :key="index"
            @click="changeTab(index,item.id)"
          >
            {{ item.name }}({{ item.listServiceCount }})
          </li>
        </ul>
      </div>
      <!-- 表单 -->
      <div class="form">
        <div class="form_title">{{ deptInfo.name }}</div>
        <div class="form_con">
          <div class="flex">
            <div class="form_con_info phone">
              联系电话：<span>{{ deptInfo.contact }}</span>
            </div>
            <div class="form_con_info">办公地址：{{ deptInfo.address }}</div>
          </div>
          <div class="form_con_info">办公时间：{{deptInfo.workTime}}</div>
          <div>
            <div class="form_con_info">部门简介</div>
            <div class="dept_desc">{{ deptInfo.introduction }}</div>
          </div>
        </div>
        <!-- 三张清单 -->
        <div class="flex form_navi">
          <div class="flex" style="border-bottom: 1px solid #ebeffc">
            <div
              v-for="(item, index) in formTabs"
              :key="index"
              :class="[
                'form_box',
                index == 0 ? '' : 'form_cls',
                formTabsIdx == index ? 'click_sty' : '',
              ]"
              @click="formTabsClick(index, item)"
            >
              {{ item }} <span v-if="index==1">
                (线上办理数量<span class="span_box">{{ onLineNumber }}</span>
                ，线下办理数量 <span class="span_box">{{ offLineNumber }}</span>，线上占比<span class="span_box">{{ onLineRate }}%</span>)</span>
              </div>
            <!-- <a-divider type="vertical" /> -->
          </div>
          <!-- <div class="total_date">
            共收录部门{{ formName }} <span>{{ pagination.total }}</span> 条
          </div> -->
          <div class="total_date" v-if="formTabsIdx==1">
            共收录部门权责清单 <span>{{ pagination.total }}</span> 条
          </div>
        </div>
        <!-- 责任清单 -->
        <!-- <div class="form_table" v-if="formTabsIdx == 0">
          <div class="form_top form_list flex">
            <div class="form_orderBy">序号</div>
            <div class="form_value">责任描述</div>
          </div>
          <div class="form_list flex" v-for="item in responseList1" :key="item.id">
            <div class="form_orderBy">{{item.id}}</div>
            <div class="form_value">{{item.desc}}</div>
          </div>
        </div> -->
        <div v-if="formTabsIdx == 0" style="margin-bottom: 60px">
          <a-table
            :columns="resColumns"
            :data-source="responseList"
            :pagination="pagination"
            rowKey="id"
            :loading="loading"
            bordered
            @change="pageChange"
          ></a-table>
        </div>
        <!-- 服务清单 -->
        <div v-if="formTabsIdx == 1" style="margin-bottom: 60px">
          <a-table
            :columns="serColumns"
            :data-source="serviceList"
            :pagination="pagination"
            rowKey="id"
            :loading="loading"
            bordered
            @change="pageChange"
          >
          <template slot="serviceClassifyNameList" slot-scope="scope">
            <span v-for="item in scope" :key="item">{{ item }}&nbsp;&nbsp;</span>
          </template>
          <template slot="targets" slot-scope="scope">
            <span v-for="item in scope" :key="item">{{ item }}&nbsp;&nbsp;</span>
          </template>
            <template slot="operation" slot-scope="scope, row">
              <div class="flex">
                <div class="bon_l" @click="gotoDetails(row.manageId)">查看详情</div>
                <div :class="[row.isApply==1?'bon_r':'disable_class']" @click="gotoWork(row.isApply,row.pcUrl)">{{row.isApply!=0?'线上办理':'线下办理'}}</div>
              </div>
            </template>
          </a-table>
        </div>
        <!-- 审批清单 -->
        <div v-if="formTabsIdx == 2" style="margin-bottom: 60px">
          <a-table
            :columns="approvalColumns"
            :data-source="approvalList"
            :pagination="pagination"
            rowKey="id"
            :loading="loading"
            bordered
            @change="pageChange"
          >
          <template slot="serviceClassifyNameList" slot-scope="scope">
            <span v-for="item in scope" :key="item">{{ item }}&nbsp;&nbsp;</span>
          </template>
          <template slot="targets" slot-scope="scope">
            <span v-for="item in scope" :key="item">{{ item }}&nbsp;&nbsp;</span>
          </template>
          <template slot="manageType" slot-scope="scope">{{ scope==1?'办事类':'应用类' }}</template>
            <template slot="operation" slot-scope="scope, row">
              <div class="flex">
                <div class="bon_l" @click="gotoDetails(row.manageId)">查看详情</div>
                <div :class="[row.isApply==1?'bon_r':'disable_class']" @click="gotoWork(row.isApply,row.pcUrl)">{{row.isApply!=0?'线上办理':'线下办理'}}</div>
              </div>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from '../components/Carousel.vue';
import imgPrefix from '../../utils/imgPrefix'
import {targetsFn} from '../../utils/utils'
import {findDepartmentApi,findNavBannerApi,findDeptByIdApi,findLiabilitiesApi,findListServiceApi,findApprovalApi,countWayNumberByListServiceApi,findNavApi} from '../api/index'
const resColumns = [
  {
    title: "序号",
    dataIndex: "orderBy",
    width: 80,
  },
  {
    title: "责任描述",
    dataIndex: "description",
  },
];
const serColumns = [
  {
    title: "序号",
    dataIndex: "orderBy",
    width: 80,
  },
  {
    title: "事项名称",
    dataIndex: "serviceManageName",
  },
  {
    title: "责任主体",
    dataIndex: "responsiblePerson",
  },
  {
    title: "类型",
    dataIndex: "serviceClassifyNameList",
    scopedSlots: { customRender: "serviceClassifyNameList" },
    width:80
  },
  {
    title: "服务范围",
    dataIndex: "targets",
    scopedSlots: { customRender: "targets" },
    width:80
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    width:180 
  },
];
const approvalColumns = [
  {
    title: "序号",
    dataIndex: "orderBy",
    width: 80,
  },
  {
    title: "事项名称",
    dataIndex: "serviceManageName",
  },
  {
    title: "事项类型",
    dataIndex: "manageType",
    scopedSlots: { customRender: "manageType" },
  },
  {
    title: "所属分类",
    dataIndex: "serviceClassifyNameList",
    scopedSlots: { customRender: "serviceClassifyNameList" },
  },
  {
    title: "服务范围",
    dataIndex: "targets",
    scopedSlots: { customRender: "targets" },
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
  },
];
export default {
  props: {},
  components: {Carousel},
  data() {
    return {
      tabsIdx: 0,
      formName: "责任清单",
      loading:false,
      tabsList: [],
      deptInfo:{},
      // formTabs: ["责任清单", "服务清单", "审批清单"],
      formTabs: ["责任概况", "权责清单",],
      formTabsIdx: 0,
      responseList: [],
      resColumns,
      serColumns,
      approvalColumns,
      serviceList: [],
      approvalList: [],
      page:1,
      pageSize:10,
      pagination: {
        total: 0,
        current:1,
        showTotal: (total) => `当前有${total}条部门记录  每页显示 1~10条`,
      },
      deptId:'', //部门id
      bannerImg: [],
      bannerInfo:{
        title:'权责清单',
        desc:'为进一步规范学校运行管理，提升内部治理效能，推动工作业务网上办、移动化、智能化发展，特编制学校二级单位权责清单。 权责清单是在学校党政群团、教辅及附属机构设置方案和学校科级机构设置及人员定岗方案（简称三定方案）基础上，进一步梳理明晰各二级单位部门及岗位职责，厘清权责事项和办事流程，明确权力行使依据与主体，以形成界线清晰、分工合理、权责一致、运转高效、依法保障的职能体系，更好地服务广大师生。'
      },
      imgPrefix,
      offLineNumber:0,
      onLineNumber:0,
      onLineRate: 0,
    };
  },
  computed: {},
  watch: {},
  created() {
    // 获取部门
    findDepartmentApi().then((res) => {
      this.tabsList = res;
      this.getDeptInfo(res[0].id)
      this.deptId = res[0].id;
      this.getTabelList(1)
      this.getcountWayNumber(res[0].id)
    });
    // this.getBanner();
    this.checkNaviArr();
  },
  mounted() {},
  methods: {
    // 判断是否有naviArr配置
    checkNaviArr(){
      let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
      if(naviTop){
        this.getBanner();
        return ;
      } else {
        findNavApi().then((res) => {
          sessionStorage.setItem("naviArr", JSON.stringify(res));
          this.getBanner();
        })
      }
    },

     // 获取banner
     getBanner() {
      let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
      naviTop.forEach(item => {
        if (item.link == "/detailedList") {
          findNavBannerApi(item.id)
            .then((res) => {
              // console.log(res);
              this.bannerImg = res;
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }
      });
    },
    // 获取部门下面的信息
    getDeptInfo(id){
      findDeptByIdApi(id).then(res => {
        // console.log(res);
        this.deptInfo = res;
      }).catch((err) => {
          this.loading = false;
          this.$message.error(err.message)
        });
    },
    // 获取表单
    getTabelList(e){
      let dto = {
        page: this.page,
        pageSize: this.pageSize,
        deptId: this.deptId
      }
      this.loading = true;
      let api = e==1?findLiabilitiesApi:e==2?findListServiceApi:findApprovalApi;
      api(dto).then(res => {
        // console.log(res);
        res.voList.list.forEach((item,idx) => {
          item.orderBy = (this.page-1)*this.pageSize+idx+1;
        })        
        this.pagination.total = res.voList.total;
        this.pagination.current = res.voList.page;
        this.loading = false;
        if(e==1){
          this.responseList=res.voList.list;
        }else if(e==2){
          res.voList.list.forEach(item => {
            let strArr = item.targets?.split(',')
            item.targets = targetsFn(strArr)            
          })
          this.serviceList=res.voList.list;
        }else if(e==3){
          res.voList.list.forEach(item => {
            let strArr = item.targets?.split(',')
            item.targets = targetsFn(strArr)
          })
          this.approvalList=res.voList.list;
        }
      }).catch((err) => {
          this.loading = false;
          this.$message.error(err.message)
        });
    },
    // 通过部门id统计服务清单的线上线下数量
    getcountWayNumber(id){
      countWayNumberByListServiceApi(id).then(res => {
        console.log(res);
        this.offLineNumber = res.offLineNumber;
        this.onLineNumber = res.onLineNumber;
        this.onLineRate = this.decimalToPercentage(res.onLineRate);
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    decimalToPercentage(num) {
      return Math.round(num * 100);
    },
    // 切换左侧边栏
    changeTab(idx,id) {
      this.page = 1;
      this.tabsIdx = idx;
      this.formTabsIdx = 0;
      this.formName = "责任清单";
      this.deptId = id;
      this.getDeptInfo(id) 
      this.getTabelList(1)     
      this.getcountWayNumber(id)      
    },
    // 切换清单tab栏
    formTabsClick(idx, name) {
      this.page = 1;
      this.formTabsIdx = idx;
      this.formName = name;
      this.responseList = [];
      this.serviceList = [];
      this.approvalList = [];
      this.getTabelList(idx+1)      
    },
    // 查看指南
    gotoDetails(id) {
      const hostUrl = "/"
      let naviTop = JSON.parse(sessionStorage.getItem('naviArr'))
      naviTop.forEach(item => {
        if(item.link == '/serviceHall'){
          // this.$router.push("/serviceDetails?naviId=" + item.id + "&serviceManageId=" + id);      
          // 构建带有ID和页面路由的URL
          const url = `#/serviceDetails?naviId=${item.id }&serviceManageId=${id}`;
          // 打开新窗口
          window.open(url, '_blank');
          
        }
      }); 
    },
    gotoWork(isApply,url) {
      // isApply字段，0显示线下办理，1显示线上办理可点击，2显示线上办理不可点击
      if(isApply==1){
        window.open(url)
      }
    },
    // 切换页码
    pageChange(pagination) {
      this.current = pagination.current;
      this.page =  pagination.current;
      this.getTabelList(this.formTabsIdx+1)
    },
  },
};
</script>

<style scoped lang="less">
.detailed_list {
  // .ban_r {
  //   width: 43%;
  //   height: 272px;
  //   background: url("../assets/sevice.png") no-repeat right;
  // }
  .detals_box {
    align-items: normal;
    margin-top: 40px;
    .tabs {
      width: 12.25rem;
      ul {
        border-right: 1px solid #edf1fd;
        margin-bottom: 0;
        width: 196px;
        overflow-y: auto;
        // max-height: 100vh;
        max-height: 953px;
        li {
          padding: 1.25rem 3.175rem 1.25rem 2.125rem;
          border-bottom: 1px solid #edf1fd;
          position: relative;
          text-align: left;
          cursor: pointer;
        }
        .li_yuan::before {
          content: "";
          position: absolute;
          top: 44%;
          left: 9%;
          width: 6px;
          height: 6px;
          background: var(--themeColor);
          border-radius: 50%;
        }
      }
    }
    .tabs_li_bg {
      border-right: 2px solid var(--themeColor);
      background: linear-gradient(
        90deg,
        #f7f8fc 0%,
        rgba(224, 229, 240, 0) 100%
      );
    }
    .form {
      margin-left: 16px;
      width: 80%;
      .form_title {
        font-size: 24px;
        font-weight: 700;
        text-align: left;
        margin-bottom: 21px;
      }
      .form_con {
        text-align: left;
        padding-left: 13px;
        .form_con_info {
          position: relative;
          margin-bottom: 8px;
          span {
            color: var(--themeColor);
          }
        }
        .form_con_info::before {
          content: "";
          position: absolute;
          top: 37%;
          left: -13px;
          width: 6px;
          height: 6px;
          background: var(--themeColor);
          border-radius: 50%;
        }
        .phone {
          margin-right: 10.9rem;
        }
        .dept_desc {
          font-size: 14px;
          color: #7a8ba4;
        }
      }
      .form_navi {
        margin-top: 3.25rem;
        margin-bottom: 1.5rem;
        justify-content: space-between;
        font-size: 16px;
        .form_box {
          padding-bottom: 11px;
          color: #374567;
          margin-left: 35px;
          margin-right: 35px;
          position: relative;
          cursor: pointer;
          .span_box{
            color: rgba(255, 122, 0, 1);
            font-weight: 600;
          }
          &:first-child {
            margin-left: 0;
          }
           &:last-child {
            margin-right: 0;
          }
        }
        // .form_box div:first-child{
        //   margin-left: 0;
        // }
       
        .click_sty {
          color: var(--themeColor);
          border-bottom: 2px solid var(--themeColor) !important;
        }
        .form_cls::after {
          content: "";
          position: absolute;
          width: 1px;
          height: 16px;
          background: #ebeffc;
          top: 9%;
          left: -34px;
        }
        .total_date {
          span {
            color: rgba(255, 122, 0, 1);
          }
        }
      }
      .form_table {
        border-top: 1px solid #e0e5f0;
        border-left: 1px solid #e0e5f0;
        margin-bottom: 13.125rem;
        .form_top {
          color: #7a8ba4;
          background: #ebeffc;
        }
        .form_list {
          border-bottom: 1px solid #e0e5f0;
          border-right: 1px solid #e0e5f0;
          .form_orderBy {
            width: 10%;
            padding: 0.875rem 14px;
          }
          .form_value {
            flex: 1;
            border-left: 1px solid #e0e5f0;
            padding: 0.775rem 14px;
          }
          .form_service_name {
            width: 40%;
            flex: auto;
          }
        }
      }
      .bon_l {
        border: 1px solid var(--themeColor);
        border-radius: 8px;
        padding: 6px 8px;
        color: var(--themeColor);
        margin-right: 12px;
        cursor: pointer;
        text-align: center;
      }
      .bon_r {
        color: #fff;
        background: var(--themeColor);
        border-radius: 8px;
        padding: 6px 8px;
        cursor: pointer;
        text-align: center;
      }
    }
  }
}
li{
  list-style: none;
}
/deep/.ant-table-pagination.ant-pagination {
  display: flex!important;
  float: none!important;
}
/deep/.ant-pagination-total-text {
  flex: 1!important;
  text-align: left;
}
/deep/.ant-table-thead > tr > th, 
/deep/.ant-table-tbody > tr > td{
  padding: 16px 8px;
}
</style>
